<template>
  <div class="circleHeight">
    <van-row type="flex" justify="space-between" class="circleTitle">
      <van-col span="10" class="nameTitle">{{name}}</van-col>
      <van-col span="14" class="buttonChange timeButton">
        <button :class="{ choose:2===time }" @click="changeTime(2)" v-if="showrateFlag.indexMonth">月</button>
        <button :class="{ choose:3===time }" @click="changeTime(3)" v-if="showrateFlag.indexYear">年</button>
        <p class="tiem-iconfont"  @click="showPopup">
          <img src="../../../../static/images/calendar.png" style="width:.21rem;height:.2rem">
        </p>
      </van-col>
    </van-row>
    <van-row type="flex" class="circle">
        <van-col span="12">
          <div v-if="time === 3">
            <p v-if="cardData.year === '--'">
              <span>{{cardData.year}}</span>{{cardData.yearUnit}}
            </p>
            <p v-else>
              <span>{{cardData.year}}</span>{{cardData.yearUnit}}
              <!-- <span>{{cardData.year | changeMoneyFilter}}</span>{{cardData.year | changeUnitFilter}}{{cardData.unit}} -->
            </p>
          </div>
          <div v-else>
            <p v-if="cardData.month === '--'">
              <span>{{cardData.month}}</span>{{cardData.monthUnit}}
            </p>
            <p v-else>
              <span>{{cardData.month}}</span>{{cardData.monthUnit}}
              <!-- <span>{{cardData.month | changeMoneyFilter}}</span>{{cardData.month | changeUnitFilter}}{{cardData.unit}} -->
            </p>
          </div>
        </van-col>
        <van-col class="ratevalue-warpper" span="6" v-show="time===3">
          <div class="ratevalue-value-second" v-if="showrateFlag.hasAchievementRate">
            <!-- <img src="../../../../static/images/splitLine.png"> -->
          </div>
          <div class="ratevalue-value" v-if="showrateFlag.hasAchievementRate">
            <span>{{cardData.achievementRate}}{{cardData.achievementRateUnit}}</span>
            <p>年达成率</p>
          </div>
        </van-col>
        <van-col class="ratevalue-warpper" span="6" v-show="time===3">
          <div class="ratevalue-value-second" v-if="showrateFlag.hasAchievementRate">
            <!-- <img src="../../../../static/images/splitLine.png"> -->
          </div>
          <div class="ratevalue-value">
            <span>{{cardData.onYearRate}}{{cardData.onYearRateUnit}}</span>
            <p>年同比</p>
          </div>
        </van-col>
    </van-row>
    <van-row type="flex" class="circleFooter">
      <van-col span="6">{{cardData.orgName}}</van-col>
      <van-col  span="18" :style="{textAlign:'right'}">统计时间：{{cardData.yearTime}} </van-col>
    </van-row>
    <van-popup v-model="show"
    position="bottom"
    :style="{ height: '40%' }">
      <van-datetime-picker
        ref="picker"
        v-if="this.showrateFlag.isPreEntry === 0"
        v-model="currentDate"
        :type="showTime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="cancel"
        @confirm="confirm"
      />
       <van-datetime-picker
        v-else-if="this.showrateFlag.isPreEntry === 1"
        ref="picker"
        v-model="currentDate"
        type="date"
        @cancel="cancel"
        @confirm="confirm"
        :formatter="formatter"
        :filter="filter"
      />
    </van-popup>
  </div>
</template>

<script>
import { postAction, getAction } from '@/utils/api'
import { getCurrentMonthLast, getCurrentTime, minTime, maxTime } from '@/utils/util'
export default {
  name: 'DetailRecord',
  data () {
    return {
      date: '',
      time: null,
      moneyData: '',
      cardData: {name: '--', month: '--', orgName: '--', year: '--', indexValue: '--'},
      tableData: {},
      showTime: 'year-month',
      name: '',
      show: false,
      currentDate: new Date(),
      minDate: '',
      maxDate: '',
      dateData: '',
      getTableflag: '',
      showrateFlag: {},
      passTime: '',
      passTimeDate: this.$route.query.passTimeDate,
      range: [],
      postChannel: '',
      postKind: '',
      postTime: '',
      postQuota: ''
    }
  },
  props: ['showFlag'],
  methods: {
    getDate () {
      let { picker } = this.$refs
      return new Date(
        Array.from(
          picker.$el.querySelectorAll('.van-picker-column__item--selected')
        ).map(_ => {
          return parseInt(_.textContent)
        }).join('/')
      )
    },
    // 通过传入filter函数，可以对选项数组进行过滤，实现自定义时间间隔
    filter (type, options) {
      if (this.range.length < 1) return []
      let currentDate = new Date(this.currentDate)
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() + 1
      let item = this.range.find(_ => +_.year === currentYear)
      let startTime = new Date(item.startTime)
      let endTime = new Date(item.endTime)
      let months = [startTime.getMonth() + 1, endTime.getMonth() + 1]
      let days = [startTime.getDate(), endTime.getDate()]
      if (type === 'year') {
        return this.range.map(_ => _.year)
      } else if (type === 'month') {
        return options.filter(_ => {
          return +_ >= months[0] && +_ <= months[1]
        })
      } else if (type === 'day') {
        if (months[0] === months[1]) {
          return Array.apply(null, { length: 31 }).map((_, i) => {
            i += 1
            return i < 10 ? '0' + i : i + ''
          }).filter(_ => +_ >= days[0] && +_ <= days[1])
          // return options.filter(_ => +_ >= days[0] && +_ <= days[1])
        }
        if (currentMonth === months[0]) {
          return options.filter(_ => +_ >= days[0])
        } else if (currentMonth === months[1]) {
          return options.filter(_ => +_ <= days[1])
        }
        return options
      }
    },
    // 通过传入formatter函数，可以对选项文字进行格式化处理 value为时间戳
    formatter (type, value) {
      if (type === 'year') {
        return `${value}`
      } else if (type === 'month') {
        return `${value}`
      }
      return value
    },
    getHomeInfo () {
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.$store.state.entirety.quota,
        channelId: this.$store.state.entirety.channel,
        date: this.dateData || ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showrateFlag = res.data
        if (this.showrateFlag.indexMonth === 0) {
          this.time = 3
        }
        this.$emit('timeData', this.time)
      })
      let postData = {
        'channelId': this.$store.state.entirety.channel,
        'classification': this.$store.state.entirety.kind,
        'indexId': [this.$store.state.entirety.quota],
        'date': this.dateData || '',
        'dateType': this.time,
        'key': '',
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId
      }
      if (this.showFlag === 1) {
        this.getTableflag = postAction('/simpapp/projectAnaly/totalPrem', postData)
      } else if (this.showFlag === 2) {
        this.getTableflag = postAction('/simpapp/structuralAnalysis/totalPrem', postData)
      }
      this.getTableflag.then((res) => {
        this.cardData = res.data
        this.name = this.cardData.name
        if (this.cardData.year === null) {
          this.cardData.year = '--'
        }
        if (this.cardData.month === null) {
          this.cardData.month = '--'
        }
        if (this.cardData.achievementRate === null || this.cardData.achievementRate === undefined) {
          this.cardData.achievementRate = '--'
        }
        if (this.cardData.achievementRate === 0) {
          this.cardData.achievementRate = 0
        }
        if (this.cardData.onYearRate === null || this.cardData.onYearRate === undefined) {
          this.cardData.onYearRate = '--'
        }
        if (this.cardData.onYearRate === 0) {
          this.cardData.onYearRate = 0
        }
      })
    },
    // 日历日月年切换，将dateDate置空表示重新初始化调取接口，不设置置空即任然保留之前选择历史日期但数据刷新改变了
    changeTime (index) {
      // this.dateData = '' // 关闭则切换年月日期任然保存之前的日期,切换月年先将日期置空
      this.$emit('postDate', this.dateData)
      this.$emit('timeData', index)
      this.time = index
      this.currentDate = new Date()
      this.getHomeInfo()
    },
    showPopup () {
      var timePost = {
        'dateType': this.time,
        'indexId': new Array(this.$store.state.entirety.quota),
        'channelId': this.$store.state.entirety.channel,
        'classification': this.$store.state.entirety.kind
      }
      this.showrateFlag.path = this.showrateFlag.isPreEntry === 1 ? '/simpapp/controlTime/preGetTime' : '/simpapp/controlTime/getTime'
      var timeObj = postAction(this.showrateFlag.path, timePost)
      timeObj.then(res => {
      // /simpapp/controlTime/preGetTime 预录入接口
        if (this.showrateFlag.path === '/simpapp/controlTime/preGetTime') {
          res.data.sort((a, b) => {
            return +a.year > +b.year ? 1 : -1
          })
          this.range = res.data
          this.show = true
          return false
        }
        // this.cardData = res
        this.passTime = res.data.yearTime
        var timeStart = res.data.startDate.split('')
        timeStart.splice(4, 0, '/')
        if (timeStart.length > 7) {
          timeStart.splice(7, 0, '/')
        }
        this.minDate = new Date(timeStart.join(''))
        if (res.data.endDate) {
          var timeEnd = res.data.endDate.split('')
          timeEnd.splice(4, 0, '/')
          if (timeEnd.length > 7) {
            timeEnd.splice(7, 0, '/')
          }
          this.maxDate = new Date(timeEnd.join(''))
        } else {
          this.maxDate = new Date()
        }
        if (this.time === 2 || this.time === 3) {
          this.showTime = 'date'
        } else {
          this.showTime = 'year-month'
        }
        this.show = true
      })
      // if (this.$store.state.entirety.quota === 'A0101-1007') { // 总保费
      //   this.minDate = fiveYearJMonth()
      // } else { // 当年一月到当前月，年初到当前
      //   this.minDate = thisYearJMonth()
      // }
      // this.show = true
    },
    cancel () {
      this.show = false
    },
    confirm () { // 日历
      this.currentDate = this.getDate()
      var curTime
      this.passTimeDate = ''
      this.show = false
      if (this.time === 2 || this.time === 3) {
        curTime = getCurrentTime(new Date())
        if (getCurrentTime(this.currentDate) === curTime) {
          this.dateData = ''
        } else {
          this.dateData = getCurrentTime(this.currentDate)
        }
        this.$emit('postDate', this.dateData, this.currentDate)
      } else {
        curTime = new Date(new Date().getFullYear(), new Date().getMonth())
        if (this.currentDate < curTime) {
          this.dateData = getCurrentMonthLast(this.currentDate)
        } else {
          this.dateData = ''
        }
        this.$emit('postDate', this.dateData)
      }
      this.getHomeInfo()

      // 获取主销产品
      let pageCode = this.$store.state.user.pageCode
      if (pageCode === '01') {
        this.postChannel = this.$store.state.entirety.channel
        this.postKind = this.$store.state.entirety.kind
        this.postTime = this.$store.state.entirety.time
        this.postQuota = this.$store.state.entirety.quota
      } else if (pageCode === '02') {
        this.postChannel = this.$store.state.per.channel
        this.postKind = this.$store.state.per.kind
        this.postTime = this.$store.state.per.time
        this.postQuota = this.$store.state.per.quota
      } else if (pageCode === '03') {
        this.postChannel = this.$store.state.bank.channel
        this.postKind = this.$store.state.bank.kind
        this.postTime = this.$store.state.bank.time
        this.postQuota = this.$store.state.bank.quota
      } else if (pageCode === '04') {
        this.postChannel = this.$store.state.team.channel
        this.postKind = this.$store.state.team.kind
        this.postTime = this.$store.state.team.time
        this.postQuota = this.$store.state.team.quota
      }
      let postData = {
        'channelId': this.postChannel,
        'classification': this.postKind,
        'dateType': this.postTime,
        'indexId': [this.postQuota],
        'date': this.dateData || '',
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId,
        'pageCode': this.$store.state.user.pageCode
      }
      let objTwo = postAction('/simpapp/Filtrate/getMainProductList', postData)
      objTwo.then((res) => {
        this.$store.commit('MAIN_PRODUCT_LIST', res)
      })
    }
  },
  mounted () {
    this.time = this.$store.state.entirety.time * 1
    this.name = this.$store.state.entirety.quotaName
    this.dateData = this.$store.state.entirety.calendarDate
    this.$emit('postDate', this.dateData)
    if (this.dateData === '') {
      this.currentDate = new Date()
    } else {
      let passTime = this.$route.query.passCurrentDate
      var thisPassTime = new Date(passTime)
      var year = thisPassTime.getFullYear()
      var month = thisPassTime.getMonth()
      var day = thisPassTime.getDate()
      this.currentDate = new Date(year, month, day)
    }
    this.minDate = minTime()
    this.maxDate = maxTime()
    this.getHomeInfo()
  },
  watch: {
    showFlag () {
      this.$nextTick(() => {
        this.getHomeInfo()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.circle p{
    color: #333;
    font-size: 0.12rem;
    line-height: 0.3rem;
    // padding :.1rem 0;
}
.circle p span {
    display: inline-block;
    margin: 0px 5px;
    color: #333;
    font-size: 0.22rem;
    font-family: '微软雅黑'
}
.ratevalue-warpper{
  display: flex;
  justify-content: space-around;
}
.ratevalue-value p{
  text-align : center;
  color : #999;
}
.ratevalue-value-second img{
  height:.35rem;
  width: 1px;
  margin-top .1rem
}
.ratevalue-value span{
  font-size : 0.20rem;
}
.tiem-iconfont{
  float: right;
  padding: 0 .12rem;
  color : #999;
}
.circleHeight {
  padding: 0px 15px 15px 15px;
  background: #fff;
}

.circleTitle {
  font-size: 0.18rem;
  font-weight: 600;
  // height: 0.45rem;
  line-height: 0.45rem;
}
.circleTitle .nameTitle {
  line-height: normal;
  margin-top .08rem
}
.circleTitle div:last-child {
  text-align: right;
}

.circleFooter {
  font-size: 0.12rem;
  color: #BDBDBD;
}

.buttonChange {
  font-size: 0;
  text-align: right;
}

.buttonChange button {
  height: 0.26rem;
  line-height: 0.26rem;
  border: none;
  margin: 0;
  font-size: 0;
  font-size: 0.14rem;
  padding: 0 15px;
  color: #39f;
  background: none;
  border: 1px solid #39f;
  border-radius: 0.02rem;
}

.timeButton button {
  border: 1px solid #F2F2F2;
  color: #999;
}

.buttonChange .choose {
  background: #3399FF;
  border: 1px solid #3399FF;
  color: #fff;
  border-radius: 0.02rem;
}
>>>.van-col--10 {
  width: 143px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/AnalyseCard.vue